import { render } from "./passingArgumentsToFunctionsComponent.vue?vue&type=template&id=5cdbf888&scoped=true"
import script from "./passingArgumentsToFunctionsComponent.vue?vue&type=script&lang=js"
export * from "./passingArgumentsToFunctionsComponent.vue?vue&type=script&lang=js"

import "./passingArgumentsToFunctionsComponent.vue?vue&type=style&index=0&id=5cdbf888&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdbf888"]])

export default __exports__